var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.6298,
    cy: 58.963,
    r: 5.03704,
    fill: "#8BB6DA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1113,
    cy: 54.2222,
    r: 5.03704,
    fill: "#5B8FCE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4072,
    cy: 47.1111,
    r: 5.03704,
    fill: "#407EC9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9628,
    cy: 37.037,
    r: 5.03704,
    fill: "#2767A9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9628,
    cy: 26.3704,
    r: 5.03704,
    fill: "#1A5099"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.8144,
    cy: 16.8889,
    r: 5.03704,
    fill: "#103861"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1113,
    cy: 9.18518,
    r: 5.03704,
    fill: "#0B263F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.037,
    cy: 5.03704,
    r: 5.03704,
    fill: "#143852"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.18547,
    cy: 16.8889,
    r: 5.03704,
    fill: "#FBFDFE"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.03704,
    cy: 26.3704,
    r: 5.03704,
    fill: "#E9EEF7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.03704,
    cy: 37.037,
    r: 5.03704,
    fill: "#E4EEF6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5927,
    cy: 47.1111,
    r: 5.03704,
    fill: "#D0E2F0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8886,
    cy: 54.2222,
    r: 5.03704,
    fill: "#B1CFE7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.37,
    cy: 58.963,
    r: 5.03704,
    fill: "#A2C5E2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.6b8cfc7b77e63d4a501318f40cdc5137.svg";
export { ForwardRef as ReactComponent };